const axios = require("axios");

export default axios;

export const createCancelTokenHandler = (apiObject: any) => {
  const cancelTokenHandler: any = {};
  Object.getOwnPropertyNames(apiObject).forEach((propertyName) => {
    const cancelTokenRequestHandler: any = {
      cancelToken: undefined,
    };

    cancelTokenHandler[propertyName] = {
      handleRequestCancellation: () => {
        // if a previous cancel token exists,
        // cancel the request
        if (cancelTokenRequestHandler.cancelToken) {
          cancelTokenRequestHandler.cancelToken.cancel(
            `${propertyName} canceled`
          );
        }

        // creating a new cancel token
        cancelTokenRequestHandler.cancelToken = axios.CancelToken.source();

        // returning the new cancel token
        return cancelTokenRequestHandler.cancelToken;
      },
    };
  });

  return cancelTokenHandler;
};
